import React from 'react'
import styled from 'styled-components'
const Styles = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    font-size: 16px;
    margin-bottom: 6px;
    font-weight: 400;
    @media screen and (max-width: 1445px){
    }
`


export const InputTitle = ({style,children}) => {
    return (
        <Styles style={style}>
            {children}
        </Styles>
    )
}